import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CompanyGridComponent } from './company-grid/company-grid.component';
import { CompanyComponent } from './company/company.component';
import { CompanyEmployeesComponent } from './company-employees/company-employees.component';
import { CompanyEmployeeEditComponent } from './company-employee-edit/company-employee-edit.component';
import { CompanyEmployeeRolesComponent } from './company-employee-roles/company-employee-roles.component';
import { DeviceLocationsComponent } from './device-locations/device-locations.component';
import { CompanySettingsComponent } from './company-settings/company-settings.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CompaniesEffects } from '../stores/global/companies/company-effects';
import { companyReducers } from '../stores/global/companies/company-reducers';
import { DeviceLocationsEffects } from '../stores/global/device-locations/device-locations-effects';
import { deviceLocationsReducers } from '../stores/global/device-locations/device-locations-reducers';
import { CabinetModule } from '../cabinet/cabinet.module';
import { IndicatorsModule } from "@progress/kendo-angular-indicators";


@NgModule({
  declarations: [
    CompanyGridComponent,
    CompanyComponent,
    CompanyEmployeesComponent,
    CompanyEmployeeEditComponent,
    CompanyEmployeeRolesComponent,
    DeviceLocationsComponent,
    CompanySettingsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CabinetModule,
    IndicatorsModule,
    StoreModule.forFeature('deviceLocations', deviceLocationsReducers),
    StoreModule.forFeature('companies', companyReducers),
    EffectsModule.forFeature([DeviceLocationsEffects]),
    EffectsModule.forFeature([CompaniesEffects]),
  ]
})
export class CompanyModule { }
